// extracted by mini-css-extract-plugin
module.exports = {"success":"success--zV1XU","successBox":"successBox--85qWW","successTitle":"successTitle--VXAk5","successIcon":"successIcon--vT1zg","successBtn":"successBtn--bnxsu"};